<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa110-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel'   //Save Excel
                    ]"
                  @btnRetrieve="btnRetrieve()"
                  @btnExcel="btnExcel()"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Ship No. : </span>
                      <v-col cols="2">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line
                            outlined
                            dense
                            label="Select"
                            @change="getBlock()"
                          ></v-select>
                      </v-col>
                      <span class="pa-1 subTitle">Block : </span>
                          <v-col cols="2">
                            <v-select
                              v-model="block"
                              :items="blockList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>

                      <!-- <span class="pa-1 subTitle">Cutter : </span>
                          <v-col cols="2">
                            <v-select
                              v-model="cutMaker"
                              :items="cutMakerList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                        <span class="pa-2 pr-0"> Cutting Period : </span>
                          <v-col cols="1">
                              <DxDateBox :value="stDate" 
                              height="30px" 
                              display-format="yyyy-MM-dd" 
                              :acceptCustomValue="false" 
                              @value-changed="e => {stDate = e.value && getStrFormat(e.value)}" />
                          </v-col>
                          <span class="pa-2"> ~ </span>
                          <v-col cols="1" class="pl-0">
                              <DxDateBox :value="edDate" 
                              height="30px" 
                              display-format="yyyy-MM-dd" 
                              :acceptCustomValue="false" 
                              @value-changed="e => {edDate = e.value && getStrFormat(e.value)}" />
                          </v-col> -->
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epmsa110" 
                    class="hipGridHeight1_1" 
                    :ref="epmsa110Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="blockSeq" caption="Seq" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="cutGrp" caption="Cut Group" width="3%" data-type="string" alignment="center" header-cell-template="cutGrpHeaderTemp" :allow-editing="false"/>
                          <template #cutGrpHeaderTemp>
                            <div> Cut<br> Group</div>
                          </template>
                    <DxColumn data-field="keySer" caption="Ser No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="assyNo" caption="Assy" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="pcsNo" caption="Piece" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="pcsType" caption="Specification" width="15%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="assyStg" caption="Assy Stage" width="5%" data-type="string" alignment="center" header-cell-template="assyStageHeaderTemp" :allow-editing="false"/>
                          <template #assyStageHeaderTemp>
                            <div> Assy<br> Stage</div>
                          </template>
                    <DxColumn data-field="nextAssy" caption="Next Assy" width="5%" data-type="string" alignment="center" header-cell-template="nextAssyHeaderTemp" :allow-editing="false"/>
                    <template #nextAssyHeaderTemp>
                      <div> Next<br> Assy</div>
                    </template>

                    <DxColumn data-field="pcsQty" caption="PCS Qty" width="5%" alignment="right" header-cell-template="pcsQtyHeaderTemp" :allow-editing="false" data-type="number" format="#,##0"/>
                    <template #pcsQtyHeaderTemp>
                      <div> PCS<br> Q'ty</div>
                    </template>

                    <DxColumn data-field="pcsWgt" caption="PCS Weight" width="5%" alignment="right" header-cell-template="pcsWgtHeaderTemp" :allow-editing="false" data-type="number" format="#,##0"/>
                    <template #pcsWgtHeaderTemp>
                      <div> PCS<br>Weight</div>
                    </template>

                    <DxColumn data-field="cutDte" caption="Cutting Date" width="5%" data-type="string" alignment="center" header-cell-template="cutDteHeaderTemp" :allow-editing="false"/>
                    <template #cutDteHeaderTemp>
                      <div> Cutting<br>Date</div>
                    </template>

                    <DxColumn data-field="reqDte" caption="Request Date" width="5%" data-type="string" alignment="center" header-cell-template="reqDteHeaderTemp" :allow-editing="false"/>
                    <template #reqDteHeaderTemp>
                      <div> Request<br>Date</div>
                    </template>

                    <DxColumn data-field="carryOutDte" caption="Carry Out Date" width="5%" data-type="string" alignment="center" header-cell-template="carryOutDteHeaderTemp" :allow-editing="false"/>
                    <template #carryOutDteHeaderTemp>
                      <div> Delivery<br>Date</div>
                    </template>

                    <DxColumn data-field="cutMakerNm" caption="Cutting Maker" width="5%" data-type="string" alignment="center" header-cell-template="cutMakerNmTemp" :allow-editing="false"/>
                    <template #cutMakerNmTemp>
                      <div> Cutting<br>Maker</div>
                    </template>

                    <DxPaging :enabled="true" :page-size="60" />
                  </DxDataGrid>
                </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxLookup,
    DxSelection,
    DxPager
} from 'devextreme-vue/data-grid'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { epmsa110, epmsa110Xls, getBlockList } from '@/api/view/hip/A/epmsa110'
import { getShipNoList} from '@/api/view/hip/A/epmsa010_kl'

import dayjs from 'dayjs';
// import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epmsa110',
  mixins: [baseview, BaseDataGrid],
  components: {  
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager  
  },

  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' ,'btnExcel'],
      epmsa110Ref: 'epmsa110Ref',
      gridMainList: [],
      shipNoList: [],
      makerCd: this.$store.state.user.makerCd,
      shipNo: '',
      block: '',
      blockList: []
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa110Ref)
    },
  },
  mounted() {
    //this.init()
    this.getList() 
    this.gridMainInstance.option('defaultPaging', false)
    //this.btnRetrieve()
  },
  methods: {
    async getList(){
      try {
        this.openLoading('searching')
        let param = {
          makerCd: this.$store.state.user.makerCd
        }
        await getShipNoList(param).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;
        })

      } finally {
      this.endLoading()
      }
    },
    async getBlock(){
      let param = {
        shipNo: this.shipNo
      }
      this.openLoading('searching')
      await getBlockList(param).then(res => {
        this.blockList = []
        this.blockList.push('')
        res.list.forEach(e => {
          this.blockList.push(e.block)
        });
        this.block = this.blockList[0]
      }).finally(() => {
        this.endLoading()
      })
    },

    async getMainList(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo : this.shipNo,
          block: this.block
        }
        console.log(params)
        await epmsa110(params).then(res => {
          let list = []
          let cnt = 1;
          res.list.forEach(e => {
            list.push(
              {
                id: cnt++ , rnum: e.rnum, blockSeq: e.blockSeq,  block : e.block, cutGrp: e.cutGrp,
                keySer: e.keySer, assyNo: e.assyNo, pcsNo: e.pcsNo,  pcsType: e.pcsType, 
                assyStg: e.assyStg, nextAssy: e.nextAssy, pcsQty: e.pcsQty,  pcsWgt: e.pcsWgt, 
                cutDte: e.cutDte, reqDte: e.reqDte, carryOutDte: e.carryOutDte, cutMakerNm: e.cutMakerNm
              }
            )
          });
          this.gridMainList = list
        })
      } finally {
      this.endLoading()
      }
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    btnExcel(){
      this.openLoading('searching')
      const param = {
          shipNo : this.shipNo,
          block: this.block
      }
      epmsa110Xls(param)
      this.endLoading()
    },
  }
}
</script>
<style lang="scss" scoped>
.epmsa110-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }

  ::v-deep.text__dely-no {
    input {
      text-align: center;
    }
  }
}
</style>